export default __webpack_public_path__ + "static/Wallop-Regular-1f61ec844aba70519d1a843cfbc9603b.woff2";